<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">
            <el-form-item label="号码：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="上游订单号：">
                <el-input v-model.trim="searchForm.upOrder" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="下游订单号：">
                <el-input v-model.trim="searchForm.downOrder" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="跨月类型：">
                <el-select v-model="searchForm.isNextMonth" clearable>
                    <el-option label="本月" value="0"></el-option>
                    <el-option label="次月" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option label="待确认" value="0"></el-option>
                    <el-option label="支付成功" value="1"></el-option>
                    <el-option label="支付失败" value="2"></el-option>
                    <el-option label="已退款" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListPageHandle">搜索</el-button>
                 <el-button type="primary" plain icon="el-icon-search" @click="getListPageHandle1">批量重试(按搜索条件)</el-button>
                <el-button type="success" plain icon="el-icon-download" @click="exportDownPackageOrder">导出</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData"
		  border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}"
		   > 
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="170" align="center"></el-table-column>
            <el-table-column prop="upPackageName" label="上游套餐名" width="80"  align="center"></el-table-column>
            <el-table-column prop="downPackageName" label="下游套餐名" width="130"  align="center"></el-table-column>
             <el-table-column  align="center"  label="上游单号" width="300">
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.upOrder">
                        <p style="color:#0000FF"> {{scope.row.upOrder}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column prop="downOrder" label="下游订单号" width="130" align="center"></el-table-column>
            <el-table-column label="上游价格（元）" width="110" align="center">
                <template v-slot="scope">{{scope.row.upPrice/100}}</template>
            </el-table-column>
            <el-table-column label="下游价格（元）" width="110" align="center">
                <template v-slot="scope">{{scope.row.downPrice/100}}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="下单时间" width="80" align="center"></el-table-column>
            <el-table-column prop="payTypeName" label="订单来源"  align="center"></el-table-column>
            <el-table-column label="支付状态" width="80" align="center">
                <template v-slot="scope">
                    <span style="color: blue;" v-if="scope.row.payState==0">待确认</span>
                    <span style="color: green;" v-else-if="scope.row.payState==1">{{scope.row.payName}}</span>
                    <span style="color: red;" v-else>{{scope.row.payName}}</span>
                </template>
            </el-table-column>
              <el-table-column  align="center"  label="备注" width="300">
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.remark">
                        <p style="color:#0000FF"> {{scope.row.remark}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column label="操作" width="160" align="center" fixed="right">
                <template v-slot="scope" >
                    <el-button type="text" size="small"  v-if="scope.row.payState == 2"   @click="buyPkgReload(scope.row)">重试购买</el-button>
                     <el-button type="text" size="small" v-if="scope.row.payState !=1" @click="buyPkgReload1(scope.row)">变更已支付</el-button>
                </template>                  
            </el-table-column>

        </el-table>       
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        
    </div>
</template>
<script>
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                downOrder: '',
                upOrder: '',
                iccid: '',
                isNextMonth: '',
                payState:'',
                time: ''
            },

            //订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('external/buy/pkg/list', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
         getListPageHandle1($event){
           this.$confirm('此操作将会按搜索提交批量提交订单（最大300订单），确定要批量重试嘛?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
                // type: 'warning'
            }).then(() => {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('external/buy/pkg/list/load', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
            })
        },
        // 导出数据
        exportDownPackageOrder() {
            this.$confirm('确定要导出吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
                // type: 'warning'
            }).then(() => {
                var data = JSON.parse(JSON.stringify(this.searchForm));
                if(data.time != ''){
                    data.startTimeString = data.time[0] + ' 00:00:00'; 
                    data.endTimeString = data.time[1] + ' 23:59:59';
                }else{
                    data.startTimeString = '';
                    data.endTimeString = '';
                }
                delete data.time;
                
                this.exportExcel('/mould/download/external/pkgList',data)
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getListPageHandle();                
        },
        //重新购买
        buyPkgReload(rowData){
            let data = {
                id: rowData.id,
                iccid: rowData.iccid,
                otherOrderNo:rowData.downOrder,
                isNextMonth :rowData.isNextMonth,
                packgeId:rowData.downPackageId
            }
            common.sysRequest('external/buy/pkg/reload', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
                
            })
        },
         //重新购买
        buyPkgReload1(rowData){
            let data = {
                id: rowData.id,
                iccid: rowData.iccid,
                otherOrderNo:rowData.downOrder,
                isNextMonth :rowData.isNextMonth,
                packgeId:rowData.downPackageId
            }
            common.sysRequest('external/buy/pkg/update', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
                
            })
        }

    
    },
    created () {
        this.getListPageHandle();
    },
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

